import { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "@/App.css";
import { LanguageProvider } from "./i18n";
import { initLenis } from "./smooth";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import Collection from "./components/Collection";
import Story from "./components/Story";
import Places from "./components/Places";
import RequestAccess from "./components/RequestAccess";
import PrivacyPage from "./components/PrivacyPage";
import TermsPage from "./components/TermsPage";
import Footer from "./components/Footer";

const Landing = () => (
    <>
        <Header />
        <main>
            <Hero />
            <Marquee />
            <Collection />
            <Story />
            <Places />
            <RequestAccess />
        </main>
        <Footer />
    </>
);

function App() {
    useEffect(() => {
        initLenis();
    }, []);

    return (
        <LanguageProvider>
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/it" element={<Landing />} />
                    <Route path="/privacy" element={<PrivacyPage />} />
                    <Route path="/it/privacy" element={<PrivacyPage />} />
                    <Route path="/terms" element={<TermsPage />} />
                    <Route path="/it/terms" element={<TermsPage />} />
                </Routes>
            </BrowserRouter>
        </LanguageProvider>
    );
}

export default App;
